module.exports = __webpack_public_path__ + "img/mobilenewsLogo6.deacfe6b.png";